import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
    Badge,
    Col,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Form,
    FormGroup,
    Modal,
    ModalBody,
    Spinner,
    UncontrolledDropdown,
} from "reactstrap";
import { string } from "yup";
import {
    BlockBetween,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Button,
    Icon,
} from "../../../components/Component";
import ReactDataTable from "./ReactDataTable/ReactDataTable";
import ToastExample from "../../../helpers/toast";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import {
    getAllStoreCategories,
    toggleCategory,
    createStoreCategory,
    updateStoreCategory,
    deleteCategory,
} from "../../../redux/admin/store/action";
import * as yup from "yup";
import { nonActiveFormSubmissionStatus, openFormLoading } from "../../../redux/common/actions";
import { WEBSITE_BASE_URL } from "../../../config";
import noimage from '../../../assets/images/noimage.png'
import { Image, Table } from "antd";
import { ColorRing } from "react-loader-spinner";


const StoreCategories = () => {
    const dispatch = useDispatch(); //defining dispatch
    //function to get data from backend
    useEffect(() => {
        localStorage.removeItem('itemCurrentPage')
        dispatch(getAllStoreCategories()).then((response) => {
            if (response.payload.length > 0) {
                setLoading(false)
            }
        })
    }, []);

    //to store data from application state to a constant
    const getSelectors = (state) => ({
        store_categories: state.store.store_categories,
        form_loading: state.common.form_loading,
        form_submission_status: state.common.form_submission_status,
    });
    const { store_categories, form_loading, form_submission_status } = useSelector(getSelectors);
    const [loading, setLoading] = useState(true);

    const [showToast, setShowToast] = useState(false); //toast state

    const [editingCategory, setEditingCategory] = useState([]); //edit category state

    const [deletingCategory, setDeletingCategory] = useState([]); //delete category state

    const [formData, setFormData] = useState([]); //form data state defined

    const [data, setData] = useState([]); //data state defined
    const [image, setImage] = useState([]);

    //modal state
    const [modal, setModal] = useState({
        edit: false,
        add: false,
        delete: false,
    });

    // useEffect(() => {
    //     if(modal.edit === false || modal.add === false) {
    //         dispatch(getAllStoreCategories());
    //     }
    // }, [modal])

    //to open add modal
    const openAddModal = () => {
        setEditingCategory([]);
        dispatch(nonActiveFormSubmissionStatus());
        setImage(null)
        setTimeout(() => {
            setModal({ add: true });
        }, 100);
    };

    //to open edit modal
    const openEditModal = (category) => {
        setModal({ edit: true });
        dispatch(nonActiveFormSubmissionStatus());
        setImage(null)
        setEditingCategory(category);
    };

    //to open delete modal
    const openDeleteModal = (category) => {
        setModal({ delete: true });
        dispatch(nonActiveFormSubmissionStatus());
        setDeletingCategory(category);
    };

    //form validation with yup
    const categorySchema = yup.object({
        name: string().required(),
    });

    //form values
    const defaultValues = useMemo(
        () => ({
            id: editingCategory?.id || "",
            name: editingCategory?.name || "",
        }),
        [editingCategory]
    );

    //form methods
    const methods = useForm({
        resolver: yupResolver(categorySchema),
        defaultValues: defaultValues,
    });

    //useform methods
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = methods;

    //submit function to category
    const onFormSubmit = (submitData) => {
        dispatch(openFormLoading());
        const new_data = new FormData();
        new_data.append('id', editingCategory?.id);
        new_data.append('name', submitData?.name);
        if (image) {
            new_data.append('image', image)
        }
        if (modal.edit) {
            setTimeout(() => {
                dispatch(updateStoreCategory(new_data));
            }, 50);
        } else if (modal.add) {
            dispatch(createStoreCategory(new_data));
        } else if (modal.delete) {
            dispatch(deleteCategory(deletingCategory?.id));
        }
        resetForm();
    };

    //submit toast
    useEffect(() => {
        if (modal.add == true && form_loading == false && form_submission_status == true) {
            setTimeout(() => {
                dispatch(getAllStoreCategories());
                setData(store_categories);
                setModal({ add: false });
                setShowToast(true);
            }, 500);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        }

        if (modal.edit == true && editingCategory && form_loading == false && form_submission_status == true) {
            dispatch(getAllStoreCategories());
            setData(store_categories);
            setModal({ edit: false });
            setShowToast(true);
            reset(defaultValues);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        } else {
            reset(defaultValues);
        }

        if (modal.delete == true && form_loading == false && form_submission_status == true) {
            setTimeout(() => {
                dispatch(getAllStoreCategories());
                setData(store_categories);
                setModal({ delete: false });
                setShowToast(true);
            }, 500);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        }
    }, [createStoreCategory, form_loading, modal, form_submission_status]);

    // to reset the form
    const resetForm = () => {
        setFormData({
            name: "",
        });
    };

    //to close modal
    const onFormCancel = () => {
        setModal({ edit: false, add: false, delete: false });
        document.getElementByClass("invalid").innerHTML = "";
        resetForm();
    };

    //category toggle
    const handleCategoryStatus = (e, id) => {
        dispatch(toggleCategory(id));
        setTimeout(() => {
            dispatch(getAllStoreCategories());
            setShowToast(true);
        }, 500);

        setTimeout(() => {
            setShowToast(false);
        }, 3000);
    };


    const tableHeadings = [
        {
            name: "Id",
            selector: (row) => row.id,
            sortable: true,
        },
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
        },
        {
            name: "Image",
            selector: (row) => row.image,
            cell: (row) => (
                <div className="user-card mt-2 mb-2">
                    <Image
                        style={{
                            height: "15vh",
                            width: "15vh",
                            objectFit: 'cover',
                        }}
                        src={row?.image ? row?.image : noimage}
                    />
                </div>
            )
        },
        {
            name: "Status",
            selector: (row) => row.startDate,
            cell: (row) => (
                <Button color={row?.is_active ? "success" : "danger"} onClick={(e) => {
                    handleCategoryStatus(e, row?.id)
                }}>
                    {row?.is_active ? <Icon name="stop-circle-fill" /> : <Icon name="play-circle-fill" />}
                </Button>
            )
        },
        {
            name: "Action",
            selector: (row) => row.salary,
            cell: (row) => (
                <div className="user-card mt-2 mb-2">
                    <DropdownTrans row={row} />
                </div>
            )
        },
    ];

    //action dropdown
    const DropdownTrans = ({ row }) => {
        return (
            <UncontrolledDropdown>
                <DropdownToggle tag="a" className="text-soft dropdown-toggle btn btn-icon btn-trigger">
                    <Icon name="more-h"></Icon>
                </DropdownToggle>
                <DropdownMenu right>
                    <ul className="link-list-plain">
                        <li>
                            <DropdownItem tag="a" onClick={() => openEditModal(row)}>
                                <Icon name="pen" />
                                Edit
                            </DropdownItem>
                        </li>
                        <li>
                            <DropdownItem tag="a" href="#dropdownitem" onClick={() => openDeleteModal(row)}>
                                <Icon name="trash" />
                                Delete
                            </DropdownItem>
                        </li>
                    </ul>
                </DropdownMenu>
            </UncontrolledDropdown>
        );
    };

    return (
        <React.Fragment>
            {loading ? (
                <Content >
                    <div className='d-flex align-items-center justify-content-center' style={{ minHeight: '75vh' }}>
                        <ColorRing
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="blocks-loading"
                            wrapperStyle={{}}
                            wrapperClass="blocks-wrapper"
                            colors={['#fcc314', '#fcc314', '#fcc314', '#fcc314', '#fcc314']}
                        />
                    </div>
                </Content>
            ) :
                <React.Fragment>
                    <Head title="Store Categories"></Head>
                    {/* add and edit modal */}
                    <Modal
                        isOpen={modal.add || modal.edit}
                        toggle={() => setModal({ add: false })}
                        className="modal-dialog-centered"
                        size="lg"
                        onExit={() => {
                            dispatch(getAllStoreCategories());
                        }}
                    >
                        <ModalBody>
                            <a
                                href="#cancel"
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    onFormCancel();
                                }}
                                className="close"
                            >
                                <Icon name="cross-sm"></Icon>
                            </a>
                            <div className="p-2">
                                <h5 className="title">{modal.edit ? "Editing Category - " + editingCategory?.name : "Add Category"}</h5>
                                <div className="mt-4">
                                    <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)} encType="multipart/formData">
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Category Name</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="name"
                                                    placeholder="Enter Category Name"
                                                    ref={register({ required: "This field is required" })}
                                                />
                                                {errors.name && <span className="invalid">{errors.name.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" >Image </label>
                                                <input
                                                    className="form-control"
                                                    type="file"
                                                    name="image"
                                                    accept="image/png, image/jpeg, image/jpg"
                                                    onChange={(e) => {
                                                        setImage(e.target.files[0])
                                                    }}
                                                />
                                                {errors.image && <span className="invalid">{errors.image.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="12" style={modal.edit ? { display: 'block' } : { display: 'none' }}>
                                            <FormGroup>
                                                <label className="form-label">Current Image </label>
                                                <div className="my-2" id={editingCategory.id}>
                                                    {editingCategory?.image ?
                                                        <Image
                                                            style={{
                                                                objectFit: 'cover', height: '20vh'
                                                            }}
                                                            src={editingCategory?.image}
                                                        />
                                                        :
                                                        <>
                                                            <img src={noimage} alt="item category" style={{ height: '7vh', width: '7vh' }} />
                                                            <span className='m-1' style={{ color: '#330033', fontSize: '9px' }}>No image found</span>
                                                        </>
                                                    }
                                                </div>
                                            </FormGroup>
                                        </Col>


                                        <Col size="12">
                                            <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                                <li>
                                                    <Button type="submit" color="primary" size="lg" className="btn-block">
                                                        {form_loading ? (
                                                            <>
                                                                <Spinner size="sm" color="light" /> {modal.edit ? "Updating Category" : "Creating New Category"}
                                                            </>
                                                        ) : (
                                                            <React.Fragment>{modal.edit ? "Update Category" : "Add New Category"}</React.Fragment>
                                                        )}
                                                    </Button>
                                                </li>
                                                <li>
                                                    <a
                                                        href="#cancel"
                                                        onClick={(ev) => {
                                                            ev.preventDefault();
                                                            onFormCancel();
                                                        }}
                                                        className="link link-light"
                                                    >
                                                        Cancel
                                                    </a>
                                                </li>
                                            </ul>
                                        </Col>
                                    </Form>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>

                    {/* content */}
                    <Content>
                        <BlockHead size="sm">
                            <BlockBetween>
                                <BlockHeadContent>
                                    <BlockTitle tag="h3" page>
                                        Store Category Lists
                                    </BlockTitle>
                                    <BlockDes className="text-soft">
                                        <p>You have total {store_categories?.length} categories.</p>
                                    </BlockDes>
                                </BlockHeadContent>
                                <BlockHeadContent>
                                    <div className="toggle-wrap nk-block-tools-toggle">
                                        <ToastExample
                                            show={showToast}
                                        />
                                        <div className="toggle-expand-content">
                                            <ul className="nk-block-tools g-3">
                                                {/* <li>
                                            <a
                                                href="#export"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                }}
                                                className="btn btn-white btn-outline-light"
                                            >
                                                <Icon name="download-cloud"></Icon>
                                                <span>Export</span>
                                            </a>
                                        </li> */}
                                                <li className="nk-block-tools-opt">
                                                    <Button color="primary" className="btn-icon"
                                                        onClick={() => openAddModal()}
                                                    >
                                                        <Icon name="plus"></Icon>
                                                    </Button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </BlockHeadContent>
                            </BlockBetween>
                        </BlockHead>
                        <ReactDataTable data={store_categories} columns={tableHeadings} expandableRows pagination />

                    </Content>

                    {/* delete modal */}
                    <Modal
                        isOpen={modal.delete}
                        toggle={() => setModal({ delete: false })}
                        className="modal-dialog-centered"
                    // size="lg"
                    >
                        <ModalBody className="pt-3 pb-2">
                            <a
                                href="#cancel"
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    onFormCancel();
                                }}
                                className="close"
                            >
                                <Icon name="cross-sm"></Icon>
                            </a>
                            <div className="p-2">
                                <h5 className="title">
                                    Delete Category <Badge color="primary">{deletingCategory?.name}</Badge> ?
                                </h5>
                                <div className="mt-2">
                                    <span>This store category will be deleted. Do you really want to delete this category ?</span>
                                </div>
                                <div className="mt-3">
                                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4">
                                        <li>
                                            <Button
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    onFormSubmit();
                                                }}
                                                color="danger"
                                                className="px-4 btn-block"
                                            >
                                                {form_loading ? (
                                                    <>
                                                        <Spinner size="sm" color="light" />
                                                        Deleting
                                                    </>
                                                ) : (
                                                    <React.Fragment>Delete</React.Fragment>
                                                )}
                                            </Button>
                                        </li>
                                        <li>
                                            <a
                                                href="#cancel"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                    onFormCancel();
                                                }}
                                                className="link link-light"
                                            >
                                                Cancel
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>
                </React.Fragment>
            }
        </React.Fragment>
    );
};

export default StoreCategories;
